import { useList, useDetail, useCreate, useUpdate, useDelete, usePartialUpdate } from "@inmagik/react-crud"
import { GruppoDiRicerca, GruppoDiRicercaFormType } from "../types"
import { API_URL } from "../constants"

export function useGruppiDiRicerca(params: Record<string, string> = {}) {
  return useList<GruppoDiRicerca>(`${API_URL}/admin/gruppi-di-ricerca`, {
    query: params,
  })
}

export function useGruppoDiRicerca(id: number | undefined) {
  return useDetail<GruppoDiRicerca>(`${API_URL}/admin/gruppi-di-ricerca`, id?.toString())
}

export function useGruppoDiRicercaCreate() {
  return useCreate<GruppoDiRicerca, GruppoDiRicercaFormType>(`${API_URL}/admin/gruppi-di-ricerca`, {
    encode: "formdata",
  })
}

export function useGruppoDiRicercaUpdate() {
  return useUpdate<GruppoDiRicerca, GruppoDiRicercaFormType>(`${API_URL}/admin/gruppi-di-ricerca`, {
    encode: "formdata",
  })
}

export function useGruppoDiRicercaPartialUpdate() {
  return usePartialUpdate<GruppoDiRicerca, GruppoDiRicercaFormType>(`${API_URL}/admin/gruppi-di-ricerca`, {
    encode: "formdata",
  })
}


export function useGruppoDiRicercaDelete() {
  return useDelete<GruppoDiRicerca>(`${API_URL}/admin/gruppi-di-ricerca`)
}